'use client'
import type { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { mq, getP14, designGrid } from '@/styles'

type Props = {
  children: ReactNode
}

export const MainLegal: FC<Props> = ({ children }) => {
  return <Main><Section>{children}</Section></Main>
}

const Main = styled.main`
  ${designGrid({})}
`

const Section = styled.section`
  grid-column: 1 / span 6;
  padding-top: 40px;

  ${mq.greaterThan('tablet')} {
    grid-column: 1 / span 12;
  }


  h2, h3, h4, h5, h6, p, dd, li {
    ${getP14()}
    text-align: left;
  }

  h2, h3, h4, h5, h6, dt {
    font-weight: 500;
  }

  > p {
    margin-bottom: 15px;
  }

  > h2 {
    margin-bottom: 30px;
  }

  hr {
    background-color: var(--color-text);
    display: inline-block;
    margin-bottom: 50px;
    margin-top: 25px;
    opacity: .25;
    width: 100%;
  }

  ol {
    counter-reset: item;

    > li {
      display: block;
      list-style-type: decimal;
      margin-bottom: 60px;

      &:before {
        content: counters(item, '.') ' ';
        counter-increment: item;
        font-weight: 500;
        margin-right: 15px;
      }

      h2, h3 {
        display: inline-block;
        text-indent: 8px;
      }

      li {
        margin-bottom: 10px;
      }

      ul {
        li {
          margin-bottom: 0;
          margin-left: 18px;
          padding-left: 5px;
        }
      }
    }

    p {
      margin-bottom: 30px;

      > button {
        display: inline-block;
        margin-bottom: 0;
      }
    }

    dl dd,
    ul li {
      display: list-item;
      list-style-type: disc;
      margin-left: 20px;
    }

    a {
      color: var(--color-blue);
      text-decoration: underline;
      text-decoration-color: rgba(255, 255, 255, 0);
      transition: 300ms text-decoration-color ease-out;

      &:hover {
        text-decoration-color: var(--color-blue);
      }
    }

    strong, dt {
      font-weight: 500;
    }

    table {
      text-align: left;

      th {
        font-weight: 400;
        padding-right: 20px;
      }
    }
  }
`
